import { useForm } from 'react-hook-form';

import { useCartCoupon } from '../../../hooks/useCartCoupon';

type CartCouponApplyFormValues = {
  couponCode: string;
};

export const useCartCouponApplyForm = () => {
  const { apply, isLoading, hasAppliedCoupon, errorMessage } = useCartCoupon();

  const { control, handleSubmit, watch } = useForm<CartCouponApplyFormValues>({
    defaultValues: { couponCode: '' },
  });

  const couponCode = watch('couponCode') ?? '';
  const isSubmitEnabled = Boolean(couponCode.trim());

  const onSubmit = handleSubmit((data) => {
    apply(data.couponCode);
  });

  return {
    control,
    isLoading,
    hasAppliedCoupon,
    errorMessage,
    isSubmitEnabled,
    onSubmit,
  };
};

export default useCartCouponApplyForm;
